<template>
  <div class="wrapper">
    <b-overlay :show="isLoading" rounded="sm" @shown="onShown">
      <b-breadcrumb>
        <b-breadcrumb-item>YOU ARE HERE</b-breadcrumb-item>
        <b-breadcrumb-item>
          <router-link tag="a" to="/app/applications">
            Applications</router-link
          >
        </b-breadcrumb-item>
        <b-breadcrumb-item>{{ formName }}</b-breadcrumb-item>
        <b-breadcrumb-item active>{{ modulName }}</b-breadcrumb-item>
      </b-breadcrumb>
      <b-container fluid>
        <b-card>
          <template>
            <b-card sub-title="Filter">
              <b-row>
                <b-col cols="4">
                  <b-form-group
                    label="Business Unit"
                    label-for="bu-select"
                    label-cols="3"
                    label-size="sm"
                    v-slot="{ ariaDescribedby }"
                  >
                    <v-select
                      id="bu-select"
                      v-model="filters.business_unit"
                      :options="businessUnitOpt"
                      size="sm"
                      label="code"
                      :reduce="(i) => i.code"
                      :aria-describedby="ariaDescribedby"
                    >
                    </v-select>
                  </b-form-group>
                  <b-form-group
                    label="Location"
                    label-for="location-select"
                    label-cols="3"
                    label-size="sm"
                  >
                    <v-select
                      id="location-select"
                      v-model="filters.location"
                      :options="items"
                      size="sm"
                      label="location_name"
                      :reduce="(i) => i.location_name"
                    >
                    </v-select>
                  </b-form-group>
                </b-col>
                <b-col cols="4">
                  <b-form-group
                    label="Search"
                    label-for="inputSearch"
                    label-cols="3"
                    label-size="sm"
                  >
                    <b-input-group size="sm">
                      <b-form-input
                        id="inputSearch"
                        v-model="filter"
                        type="search"
                        placeholder="Type to Search"
                        trim
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''"
                          >Search</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <!-- <b-form-checkbox
                    v-model="filters.is_active"
                    name="check-button"
                    switch
                  >
                    <template v-if="filters.is_active === true">
                      Active
                    </template>
                    <template v-else> Inactive </template>
                  </b-form-checkbox> -->
                </b-col>
              </b-row>
            </b-card>
          </template>
          <template v-slot:header>
            <b-row>
              <b-col sm="auto" md="9">
                <div class="text-left">
                  <h4>Location</h4>
                </div>
              </b-col>
              <b-col sm="auto" md="3">
                <div class="text-right">
                  <b-button
                    variant="success"
                    size="sm"
                    v-on:click="show = !show"
                    >Create</b-button
                  >
                </div>
              </b-col>
            </b-row>
          </template>
          <b-table
            responsive
            head-variant="dark"
            stickyColumn
            striped
            hover
            show-empty
            :per-page="paging.perPage"
            :current-page="paging.currentPage"
            :items="filtered"
            :fields="fields"
            :filter="filter"
            :filter-included-fields="includeFiled"
          >
            <template #cell(is_active)="{ item }">
              <div v-if="item.is_active !== true">Inactive</div>
              <div v-if="item.is_active === true">Active</div>
            </template>
            <template v-slot:cell(actions)="{ item }">
              <b-button
                title="Hapus"
                size="xs"
                variant="danger"
                v-on:click="deleteData(item.id)"
              >
                <b-icon icon="trash-fill" aria-label="Help"></b-icon>
              </b-button>
              <b-button
                title="Ubah"
                size="xs"
                variant="warning"
                v-on:click="
                  editData(
                    item.id,
                    item.location_name,
                    item.business_unit,
                    item.is_active
                  )
                "
              >
                <b-icon icon="pencil-square" aria-label="Help"></b-icon>
              </b-button>
            </template>
          </b-table>
          <div class="mt-3">
            Showing {{ pageItems }} of {{ items.length }} entries
            <b-pagination
              v-model="paging.currentPage"
              :total-rows="rows"
              :per-page="paging.perPage"
              align="right"
            >
            </b-pagination>
          </div>
        </b-card>
        <template>
          <!-- <b-modal
            v-model="show"
            @ok="onSubmit()"
            @hidden="cancel()"
            ok-title="Save"
            cancel-title="Cancel"
            ok-variant="success"
            cancel-variant="warning"
            header-bg-variant="secondary"
            footer-bg-variant="secondary"
            hide-backdrop
            size="lg"
            ref="modal"
            no-close-on-backdrop
            title="Form Location"
          > -->
          <b-modal
            v-model="show"
            ref="my-modal"
            header-bg-variant="secondary"
            footer-bg-variant="secondary"
            hide-backdrop
            size="lg"
            title="Form Location"
          >
            <div id="modal">
              <validation-observer ref="observer" v-slot="{ handleSubmit }">
                <b-form @submit.prevent="handleSubmit(onSubmit)">
                  <b-row>
                    <b-col cols="12">
                      <!-- Business Unit -->
                      <validation-provider
                        name="BusinessUnit"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group
                          label-cols="3"
                          label-cols-lg="3"
                          label-size="sm"
                        >
                          <template v-slot:label>
                            Business Unit<code>*</code>
                          </template>
                          <b-form-select
                            value-field="code"
                            text-field="name"
                            :options="businessUnitOpt"
                            id="inputBusinessUnit"
                            v-model="form.business_unit"
                            :state="getValidationState(validationContext)"
                            trim
                          >
                          </b-form-select>
                          <b-form-invalid-feedback id="inputBusinessUnit">{{
                            validationContext.errors[0]
                          }}</b-form-invalid-feedback>
                        </b-form-group>
                      </validation-provider>
                      <!-- /Business Unit -->

                      <!-- Location -->
                      <validation-provider
                        name="Location"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group
                          label-cols="3"
                          label-cols-lg="3"
                          label-size="sm"
                        >
                          <template v-slot:label>
                            Location Name<code>*</code>
                          </template>
                          <b-form-input
                            id="inputLocation"
                            v-model="form.location_name"
                            :state="getValidationState(validationContext)"
                            trim
                          ></b-form-input>
                          <b-form-invalid-feedback id="inputLocation">{{
                            validationContext.errors[0]
                          }}</b-form-invalid-feedback>
                        </b-form-group>
                      </validation-provider>
                      <!-- /Location -->
                      <!-- Status -->
                      <template v-if="form.location_id">
                        <validation-provider
                          name="Status"
                          :rules="{ required: true }"
                          v-slot="validationContext"
                        >
                          <b-form-group
                            label-cols="3"
                            label-cols-lg="3"
                            label-size="sm"
                          >
                            <template v-slot:label>
                              Status<code>*</code>
                            </template>
                            <b-form-checkbox
                              switch
                              id="inputStatus"
                              v-model="form.is_active"
                              :state="getValidationState(validationContext)"
                              trim
                            >
                              <template v-if="form.is_active === true">
                                Active
                              </template>
                              <template v-else> Inactive </template>
                            </b-form-checkbox>
                            <b-form-invalid-feedback id="inputStatus">{{
                              validationContext.errors[0]
                            }}</b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </template>
                      <!-- /Status -->
                    </b-col>
                  </b-row>
                  <!-- penambahan terbaru -->
                  <b-row class="float-right">
                    <b-button class="mr-3" variant="success" @click="onSubmit()"
                      >Save</b-button
                    >
                    <b-button class="mr-3" variant="warning" @click="cancel()"
                      >Cancel</b-button
                    >
                  </b-row>
                </b-form>
              </validation-observer>
            </div>
            <template #modal-footer>
              <div class="h-300 bg-secondary"></div>
            </template>
          </b-modal>
        </template>
      </b-container>
      <template #overlay>
        <div ref="loadings" class="text-center">
          <b-icon
            icon="arrow-clockwise"
            font-scale="3"
            animation="spin"
          ></b-icon>
          <p id="cancel-label">Please wait...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import { fnGET, fnPOST, fnPUT, fnDELETE } from "../../../../../api/api-methods";
import { APIPATH_DMS, APIPATH_BBIAPPS } from "../../../../../api/api-paths";
import { mapGetters, mapActions } from "vuex";
import Vue from "vue";
export default {
  data() {
    return {
      formName: "Location",
      modulName: "Dashboard",
      items: [],
      fields: [
        { key: "actions", label: "#" },
        { key: "business_unit", label: "Business Unit", sortable: true },
        { key: "location_name", label: "Location Name", sortable: true },
        { key: "is_active", label: "Status" },
        { key: "created_by", label: "Created By" },
        {
          key: "created_at",
          label: "Created At",
          formatter: this.setDateFormat,
        },
        { key: "modified_by", label: "Updated By" },
        {
          key: "modified_at",
          label: "Updated At",
          formatter: this.setDateFormat,
        },
      ],
      paging: {
        perPage: 10,
        currentPage: 1,
      },
      isLoading: false,
      form: {
        location_id: null,
        location_name: null,
        business_unit: null,
        is_active: null,
        created_by: null,
        modified_by: null,
        deleted_by: null,
      },
      show: false,
      businessUnitOpt: [],
      filters: {
        business_unit: null,
        location: null,
        is_active: true,
      },
      filter: null,
      includeFiled: ["business_unit", "location_name", "is_active"],
      statusOpt: [
        { value: true, label: "Active" },
        { value: false, label: "Inactive" },
      ],
    };
  },
  computed: {
    ...mapGetters("session", ["userData"]),
    rows() {
      if (this.items) {
        return this.filtered.length;
      }
    },
    filtered() {
      var bu = this.filters.business_unit;
      var location = this.filters.location;
      var status = this.filters.is_active;

      return this.items.filter(function (item) {
        var filtereds = true;
        if (bu && bu.length > 0) {
          filtereds = item.business_unit === bu;
        }
        if (filtereds) {
          if (location && location.length > 0) {
            filtereds = item.location_name === location;
          }
        }
        if (filtereds) {
          if (status === false) {
            filtereds = item.is_active === false;
          } else {
            filtereds = item.is_active === true;
          }
        }
        return filtereds;
      });
    },
    pageItems() {
      var totalPage = Math.ceil(this.rows / this.paging.perPage);
      if (this.paging.currentPage === totalPage) {
        return (
          (this.rows % this.paging.perPage) +
          this.paging.perPage * totalPage -
          this.paging.perPage
        );
      } else {
        return this.paging.perPage * this.paging.currentPage;
      }
    },
  },
  methods: {
    ...mapActions("session", ["showNotification"]),
    setDateFormat(value) {
      var options = {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      };
      var formats = new Date(value).toLocaleDateString("id-ID", options);
      if (value) {
        return formats;
      }
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    getLocation() {
      Vue.set(this, "isLoading", true);
      fnGET(APIPATH_DMS.getLocation)
        .then((rsp) => {
          Vue.set(this, "items", rsp.data.payload);
        })
        .catch((err) => {
          return err;
        })
        .then(() => {
          Vue.set(this, "isLoading", false);
        });
    },
    onSubmit() {
      Vue.set(this, "isLoading", true);
      if (this.form.location_id) {
        fnPUT(APIPATH_DMS.putLocation, this.form)
          .then((rsp) => {
            this.showNotification({
              type: "success",
              message: "Successfully Submitted",
            });

            this.getLocation();
          })
          .catch((err) => {
            this.showNotification({
              type: "danger",
              message: "Failed Submitted, Something wrong",
            });

            return err;
          })
          .then(() => {
            this.cancel();
            Vue.set(this, "isLoading", false);
          });
      } else {
        // var unique = this.validationUnique()

        // if (unique.length == 0) {
        fnPOST(APIPATH_DMS.postLocation, this.form)
          .then((rsp) => {
            this.showNotification({
              type: "success",
              message: "Successfully Submitted",
            });

            this.getLocation();
          })
          .catch((err) => {
            this.showNotification({
              type: "danger",
              message: "Failed Submitted, Something wrong",
            });

            return err;
          })
          .then(() => {
            this.cancel();
            Vue.set(this, "isLoading", false);
          });
        // }else{
        //     Vue.set(this,'isLoading',false)
        //     alert('Duplicate!!!, Data already created')

        // }
      }
    },
    editData(id, name, bu, status) {
      Vue.set(this, "show", true);
      Vue.set(this.form, "location_id", id);
      Vue.set(this.form, "location_name", name);
      Vue.set(this.form, "business_unit", bu);
      Vue.set(this.form, "is_active", status);
    },
    deleteData(id) {
      this.$bvModal
        .msgBoxConfirm("Are you sure?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            Vue.set(this, "isLoading", true);
            fnPUT(APIPATH_DMS.deleteLocation, { location_id: id })
              .then((rsp) => {
                this.showNotification({
                  type: "success",
                  message: "Successfully Submitted",
                });

                this.getLocation();
              })
              .catch((err) => {
                this.showNotification({
                  type: "danger",
                  message: "Failed Submitted, Something wrong",
                });

                return err;
              })
              .then(() => {
                Vue.set(this, "isLoading", false);
              });
          }
        });
    },
    setUserData() {
      Vue.set(this.form, "created_by", this.userData.fullname);
      Vue.set(this.form, "modified_by", this.userData.fullname);
      Vue.set(this.form, "deleted_by", this.userData.fullname);
    },
    onShown() {
      // Focus the cancel button when the overlay is showing
      this.$refs.loadings.focus();
    },
    cancel() {
      Vue.set(this.form, "location_id", null);
      Vue.set(this.form, "location_name", null);
      Vue.set(this.form, "business_unit", null);
      Vue.set(this.form, "is_active", null);
      this.$refs["my-modal"].hide();
    },
    getBU() {
      fnGET(APIPATH_BBIAPPS.listBU)
        .then((rsp) => {
          Vue.set(this, "businessUnitOpt", rsp.data.payload);
        })
        .catch((err) => {
          return err;
        });
    },
    validationUnique() {
      var locations = this.form.location_name.toLowerCase().trim();

      return this.items.filter((item) => {
        return item.location_name.toLowerCase().match(locations);
      });
    },
  },
  created() {
    this.getLocation();
    this.setUserData();
    this.getBU();
  },
};
</script>

<style>
</style>